import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

export default function FAQ() {
  const { t } = useLanguage();
  const items = t('faq.items');

  return (
    <section id="faq" className="py-24 sm:py-32" data-testid="faq-section">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#008751] block mb-4">
              {t('faq.label')}
            </span>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold"
              style={{ fontFamily: 'Outfit, sans-serif' }}
              data-testid="faq-title"
            >
              {t('faq.title')}
            </h2>
          </div>

          {/* Accordion */}
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {Array.isArray(items) && items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border border-zinc-200 rounded-2xl px-6 data-[state=open]:border-[#E31C25]/30 data-[state=open]:bg-white data-[state=open]:shadow-sm transition-all"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left text-base font-semibold text-zinc-900 hover:no-underline py-5"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                  data-testid={`faq-trigger-${i}`}
                >
                  {item.question}
                </AccordionTrigger>
                <AccordionContent
                  className="text-zinc-600 leading-relaxed pb-5 whitespace-pre-line"
                  data-testid={`faq-content-${i}`}
                >
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
